import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useLogin } from "./useLogin";
import { LoadingButton } from "../LoadingButton/LoadingButton";
import Copyright from "../Copyright/Copyright";
import "./Login.scss";
import railwaylogo from "../../assets/Images/railwaylogo.png";
import { useState } from "react";
import { Visibility, VisibilityOff, Email, Phone, Lock, Key } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { InputAdornment, Divider } from "@mui/material";

const tamsLogo = require("../../assets/Images/tams_logo.png");

const SecurityInput = ({ state, inputType, sendOTP, handleChange }: any) => {
  const [showPassword, setShowPassword] = useState(false);

  if (!inputType) return null;

  if (inputType === "mobile") {
    if (state.secretkey === "") {
      return (
        <LoadingButton
          className="otp-button"
          variant="outlined"
          fullScreen
          onClick={sendOTP}
          loading={state.otpButtonLoading}
        >
          Send OTP
        </LoadingButton>
      );
    }
    return (
      <TextField
        required
        fullWidth
        className="login-input"
        label="Enter OTP"
        placeholder="Enter 6-digit OTP"
        type="text"
        value={state.password}
        error={state.passwordError}
        onChange={(event) => handleChange("password", event.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Key className="input-icon" />
            </InputAdornment>
          ),
        }}
      />
    );
  }

  return (
    <TextField
      required
      fullWidth
      className="login-input"
      label="Password"
      placeholder="Enter your password"
      type={showPassword ? "text" : "password"}
      value={state.password}
      error={state.passwordError}
      onChange={(event) => handleChange("password", event.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Lock className="input-icon" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
              className="visibility-toggle"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default function Login() {
  const { state, handleSubmit, handleChange, inputType, sendOTP }: any = useLogin();
  const props = { state, inputType, sendOTP, handleChange };

  return (
    <>
      <CssBaseline />
      <Box className="login-page">
        {/* Background with overlay */}
        <div className="login-background" />
        <div className="login-overlay" />

        {/* Top Banner */}
        <header className="login-header">
          <div className="header-content">
            <img src={railwaylogo} className="railway-logo" alt="Indian Railways" />
            <div className="header-text">
              <Typography variant="h5" className="header-title">
                Indian Railways
              </Typography>
              <Typography variant="body2" className="header-subtitle">
                Ministry of Railways, Government of India
              </Typography>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="login-main">
          <div className="login-card">
            {/* Logo Section */}
            <div className="logo-section">
              <img className="tams-logo" src={tamsLogo} alt="TAMS Logo" />
              <Typography variant="h5" className="app-title">
                TAMS
              </Typography>
              <Typography variant="body2" className="app-subtitle">
                Telecom Asset Management System
              </Typography>
            </div>

            <Divider className="login-divider" />

            {/* Welcome Text */}
            <div className="welcome-section">
              <Typography variant="h6" className="welcome-title">
                Welcome Back
              </Typography>
              <Typography variant="body2" className="welcome-subtitle">
                Sign in to continue to your dashboard
              </Typography>
            </div>

            {/* Login Form */}
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              className="login-form"
            >
              <TextField
                required
                fullWidth
                className="login-input"
                label="Email or Mobile Number"
                placeholder="Enter email or 10-digit mobile"
                value={state.userName}
                error={state.userNameError}
                onChange={(event) => handleChange("userName", event?.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {inputType === "mobile" ? (
                        <Phone className="input-icon" />
                      ) : (
                        <Email className="input-icon" />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <SecurityInput {...props} />

              {state.errorMsg && (
                <div className="error-message">
                  <Typography variant="caption">{state.errorMsg}</Typography>
                </div>
              )}

              <LoadingButton
                loading={state.loading}
                type="submit"
                fullWidth
                variant="contained"
                className="submit-button"
              >
                {state.loading ? "Signing in..." : "Sign In"}
              </LoadingButton>
            </Box>

            {/* Help Text */}
            <div className="help-section">
              <Typography variant="caption" className="help-text">
                Having trouble signing in? Contact your system administrator.
              </Typography>
            </div>
          </div>

          {/* Copyright */}
          <Copyright className="login-copyright" />
        </main>
      </Box>
    </>
  );
}
